module.exports = __webpack_public_path__ + "static/media/lancia-go-drive.67e21c55.png";